import { KonvaEventObject } from "konva/lib/Node";
import { pointOnLineNearestToPoint } from "../../../geometry/operation";
import { Vector2d } from "konva/lib/types";
import { Stage } from "konva/lib/Stage";

// Modified Pointer Postion
export const getConstraindedPointer = (
    point: Point2d,
    snapAngle?: number,
    prevPoint?: Point2d,
) => {
    // Snapping to angle:
    return applyConstrain(point, prevPoint, snapAngle)
}
function applyConstrain(position: Point2d, prevPoint: Point2d | undefined, snapAngle: number | undefined) {
    if (position && prevPoint && snapAngle) {
        return getConstrainedPos(prevPoint, position, snapAngle);
    } else {
        return position;
    }
}
export const getConstrainedPos = (first: Point2d, second: Point2d, snapAngle: number) => {
    const xLength = second.x - first.x;
    const yLength = second.y - first.y;
    const slope = yLength / xLength;

    let angle = Math.atan(slope)
    let angleInRad = (snapAngle / 180 * Math.PI);
    let selectedDirection = Math.round((angle) / angleInRad) * angleInRad;

    let dirX = Math.sin(-selectedDirection);
    let dirY = Math.cos(-selectedDirection);

    const inputPoint = { x: xLength, y: yLength, w: 1 }
    const inputLine: LineProjective = { a: dirX, b: dirY, c: 0 }
    const pointOnLine = pointOnLineNearestToPoint(inputPoint, inputLine);

    return ({ x: pointOnLine.x + first.x, y: pointOnLine.y + first.y });
}
// Position of Pointer in Model
export const getPointerModelPosition = (
    e: KonvaEventObject<MouseEvent>) => {

    let position = getModelPosition(e);
    // Snapping to angle:
    return position

};
// Model Position
function getModelPosition(e: KonvaEventObject<MouseEvent>) {
    const pointPos = e.target.getStage()?.pointerPos;
    const stage = e.target.getStage();
    const scale = stage?.scale();

    return stagePosition(scale, stage, pointPos);
}
function stagePosition(
    scale: Vector2d | undefined,
    stage: Stage | null,
    pointPos: Vector2d | null | undefined): Point2d {

    if (scale && stage && pointPos?.x && pointPos?.y) {
        return {
            x: (1.0 / scale?.x) * (pointPos?.x - stage?.x()),
            y: - (1.0 / scale?.y) * (pointPos?.y - stage?.y()),
        }
    } else { return { x: 0, y: 0 } }
}




